import styled from "styled-components";

export const ClockWrapper = styled.div`
  font-family: Roboto, monospace, sans-serif;
  font-size: 108px;
  font-weight: 700;
  text-shadow: rgb(50, 50, 50) 0 0 10px;
  color: #fff;
`;
